export const CONTAINER_TEMPLATES = [
  {
    id: "1col",
    label: "1 Column",
    columns: 1,responsive: {
  desktop: { columns: 1 },
  tablet: { columns: 1 },
  mobile: { columns: 1 }
}
  },
  {
    id: "2col",
    label: "2 Columns",
    columns: 2,
    responsive: {
  desktop: { columns: 2 },
  tablet: { columns: 2 },
  mobile: { columns: 1 }
}
  },
  {
    id: "3col",
    label: "3 Columns",
    columns: 3,responsive: {
  desktop: { columns: 3 },
  tablet: { columns: 2 },
  mobile: { columns: 1 }
}
  },
];
